import type { PostCreateSchema } from '@repo/schemas/post/postCreate';
import type { PostMutationOptions } from '@repo/types/posts';

import { mutationOptions, useMutation, useQueryClient, QueryClient } from '@tanstack/react-query';

import { GroupKey } from '#group/keys';

import { PostKey } from './keys';
import { PostService } from './postService';

function createGroupPostMutationOptions(queryClient: QueryClient, groupId: number) {
  return mutationOptions({
    mutationFn: (data: PostCreateSchema) => PostService.createPost(data).then((response) => response.data),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [PostKey.POSTS, data.id],
        exact: true,
      });
      queryClient.invalidateQueries({
        queryKey: [PostKey.POSTS],
        exact: true,
      });
      queryClient.invalidateQueries({
        queryKey: [GroupKey.GROUP_POSTS_INFINITE, groupId],
        exact: true,
      });
    },
  });
}

function createPostMutationOptions(queryClient: QueryClient) {
  return mutationOptions({
    mutationFn: (data: PostCreateSchema) => PostService.createPost(data).then((response) => response.data),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [PostKey.POSTS, data.id],
        exact: true,
      });
      queryClient.invalidateQueries({
        queryKey: [PostKey.POSTS],
        exact: true,
      });
      queryClient.invalidateQueries({
        queryKey: [PostKey.POSTS_INFINITE],
        exact: true,
      });
    },
  });
}

export function useCreatePost(options?: PostMutationOptions) {
  const { groupId } = options ?? {};
  const queryClient = useQueryClient();
  return useMutation(groupId ? createGroupPostMutationOptions(queryClient, groupId) : createPostMutationOptions(queryClient));
}
